"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalServerException = void 0;
class InternalServerException extends Error {
}
exports.InternalServerException = InternalServerException;
//# sourceMappingURL=internal-server-exception.js.map